import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

const phases = [
  {
    title: 'Phase 1: Foundation',
    duration: '2–3 months',
    heading: 'Build Your Base',
    description: 'Learn fundamentals and industry basics regardless of your starting point',
    points: [
      'Assessment & Skill Gap Analysis',
      'Personalized Learning Path',
      'Basic Programming Concepts',
    ],
    colorClass: 'j-phase1-gradient',
  },
  {
    title: 'Phase 2: Skill Development',
    duration: '4–8 months',
    heading: 'Master Your Craft',
    description: 'Deep dive into your chosen specialization with hands-on projects',
    points: [
      'Advanced Technical Skills',
      'Real-world Projects',
      'Industry Mentorship',
    ],
    colorClass: 'j-phase2-gradient',
  },
  {
    title: 'Phase 3: Specialization',
    duration: '3–6 months',
    heading: 'Become an Expert',
    description: 'Focus on advanced topics and build professional portfolio',
    points: [
      'Expert-level Training',
      'Capstone Projects',
      'Industry Certifications',
    ],
    colorClass: 'j-phase3-gradient',
  },
  {
    title: 'Phase 4: Corporate Readiness',
    duration: '1–2 months',
    heading: 'Land Your Dream Job',
    description: 'Interview preparation and job placement assistance',
    points: [
      'Resume Building',
      'Mock Interviews',
      'Job Placement Support',
    ],
    colorClass: 'j-phase4-gradient',
  },
];

const LearningJourney = () => {
  return (
    <div className="bg-light py-5 j-learning-journey">
      <div className="container text-center">
        <h2 className="fw-bold mb-2">Your Learning Journey</h2>
        <p className="text-muted mb-5" style={{ fontSize: '0.9rem' }}>
          A structured approach that adapts to your starting point and accelerates your career growth
        </p>

        <div className="row g-4 text-start">
          {phases.map((phase, index) => (
            <div className="col-md-6 col-lg-3" key={index}>
              <div className="bg-white rounded-4 p-4 h-100 shadow-sm d-flex flex-column">
                <span className={`badge text-white mb-2 px-3 py-3 fw-bold ${phase.colorClass}`}>
                  {phase.title}
                </span>
                <p className="text-muted small mb-2">{phase.duration}</p>
                <h5 className="fw-bold mb-2">{phase.heading}</h5>
                <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                  {phase.description}
                </p>
                <ul className="list-unstyled ps-0 mb-0">
                  {phase.points.map((point, i) => (
                    <li key={i} className="mb-2 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2" />
                      <span className="text-dark">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LearningJourney;
